import React from "react";
import ReactDOM from "react-dom";
import { Disclaimers } from "./components/Disclaimers/Disclaimers";

const disclaimers = document.getElementById("disclaimers");
if (disclaimers) {
  ReactDOM.render(<Disclaimers />, disclaimers);
}
